module.exports = __webpack_public_path__ + "img/logo_x4.e122a607.webp";